import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import AuthService from "../../services/auth.service";

const PromoCodesCRUD = () => {
  const [promoCodes, setPromoCodes] = useState([]);
  const [formData, setFormData] = useState({
    PromoCode: "",
    PackId: 0,
    Expiry: "",
    Discount: 0,
  });

  const [errors, setErrors] = useState({});


  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const API_BASE_URL = "https://s3napi-dev.s3nsoftware.com/api/UserMasters";

  useEffect(() => {
    fetchPromoCodes();

   const username =  localStorage.getItem("username");

    AuthService.getUserRole(username).then((response) => {
        if (response.UserRole === "No User") {
          alert("No User");
          return;
        }
  
        if (response.UserRole === "SuperAdmin") {
          // alert("Admin");
          return;
        }else{
          alert("You are not authorized to access this page");
            window.location.href = "*";
        }
      });
  }, []);

  const fetchPromoCodes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/GetAllPromoCodes`);
      setPromoCodes(response.data);
    } catch (error) {
      console.error("Error fetching promo codes:", error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   


   
        // Perform validation before submitting
        let newErrors = {};
      
        if (!formData.PromoCode) newErrors.PromoCode = "Promo Code is required.";
        if (!formData.PackId) newErrors.PackId = "Please select a Package.";
        if (!formData.Expiry) newErrors.Expiry = "Expiry date is required.";
        if (formData.Discount && isNaN(formData.Discount))
          newErrors.Discount = "Discount must be a valid number.";
      
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
          return; // Stop submission if errors exist
        }
      
        // Format Expiry Date Before Sending
        const formattedData = {
          ...formData,
          Expiry: formData.Expiry ? new Date(formData.Expiry).toISOString() : null, // Convert to full ISO format
        };
        setLoading(true);
    try {
      if (editingId) {
        await axios.post(
          `${API_BASE_URL}/UpdatePromoCode/${editingId}`,
          formData
        );
      } else {
        await axios.post(`${API_BASE_URL}/CreatePromoCode`, formData);
      }
      fetchPromoCodes();
      resetForm();
    } catch (error) {
      console.error("Error submitting promo code:", error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  const resetForm = () => {
    setFormData({
      PromoCode: "",
      PackId: 0,
      Expiry: "",
      Discount: 0,
    });
    setEditingId(null);
  };

  const handleEdit = (promo) => {
    setFormData(promo);
    setEditingId(promo.Id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this promo code?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        await axios.get(`${API_BASE_URL}/DeletePromoCode/${id}`);
        fetchPromoCodes();
        Swal.fire("Deleted!", "The promo code has been deleted.", "success");
      } catch (error) {
        console.error("Error deleting promo code:", error);
      } finally {
        setTimeout(() => setLoading(false), 500);
      }
    }
  };

  const [packages, setPackages] = useState([]);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const response = await axios.get(
        "https://s3napi-dev.s3nsoftware.com/api/UserMasters/GetPackages"
      );
      setPackages(response.data);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-extrabold text-center text-indigo-600 mb-6">
        🎟️ Manage Promo Codes
      </h1>

      {loading && (
        <div className="text-center mb-3">
          <Spinner animation="border" variant="primary" size="lg" />
          <p>Loading...</p>
        </div>
      )}

      <div className="bg-white shadow-lg rounded-xl p-6 mb-8 w-full">
        <h2 className="text-xl font-bold mb-4 text-gray-800">
          {editingId ? "✏️ Edit Promo Code" : "➕ Create Promo Code"}
        </h2>
        <form onSubmit={handleSubmit}>
          <table className="table table-striped table-hover table-bordered w-100">
            <thead className="table-dark">
              <tr>
                <th>Field Name</th>
                <th>Input</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(formData).map((key) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td>
                    {key === "PackId" ? (
                      <select
                        name="PackId"
                        value={formData.PackId || ""}
                        onChange={handleChange}
                        className={`form-control ${errors.PackId ? "is-invalid" : ""}`}
                        >
                        <option value="">Select a Package</option>
                        {packages.map((pkg) => (
                          <option key={pkg.Id} value={pkg.Id}>
                            {pkg.Package}
                          </option>
                        ))}
                      </select>
                    ) : key === "Expiry" ? (
                      <input
                        type="date"
                        name="Expiry"
                        value={
                          formData.Expiry ? formData.Expiry.split("T")[0] : ""
                        }
                        onChange={handleChange}
                        className={`form-control ${errors.Expiry ? "is-invalid" : ""}`}

                      />
                    ) : (
                      <input
                        type="text"
                        name={key}
                        value={formData[key] || ""}
                        onChange={handleChange}
                        className={`form-control ${errors[key] ? "is-invalid" : ""}`}
                        />
                    )}
                            {errors[key] && <div className="text-danger small">{errors[key]}</div>}

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-center" style={{ marginBottom: "1rem" }}> 
            <button type="submit" className="btn btn-primary">
              {editingId ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>

      {/* Display Promo Codes Table */}
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Promo Code</th>
            <th>Pack ID</th>
            <th>Expiry</th>
            <th>Discount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {promoCodes.map((promo) => (
            <tr key={promo.Id}>
              <td>{promo.PromoCode}</td>
              <td>{promo.PackId}</td>
              <td>{promo.Expiry}</td>
              <td>{promo.Discount}</td>
              <td>
                <button onClick={() => handleEdit(promo)}>✏️</button>
                <button onClick={() => handleDelete(promo.Id)}>❌</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PromoCodesCRUD;
